
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/calendar/calendar.component.js'
      import type { DdsChangeEvent } from '../../events/events'
      export type { DdsChangeEvent } from '../../events/events'

      const tagName = 'dap-ds-calendar'

      /**
 * `dap-ds-calendar`
 * @summary A calendar is a visual representation of dates. It allows users to select a date.
 * @element dap-ds-calendar
 * @title - Calendar
 *
 * @event {{ value: Dayjs }} dds-change - Fired when the calendar value changes.
 *
 * @slot - The content of the calendar.
 *
 * @csspart base - The main calendar container.
 * @csspart header - The header of the calendar.
 * @csspart body - The body of the calendar.
 *
 * @cssproperty --dds-calendar-display - The display property of the calendar container. Default is flex.
 * @cssproperty --dds-calendar-isolation - The isolation property of the calendar. Default is isolate.
 * @cssproperty --dds-calendar-block-display - The display property of the calendar block. Default is block.
 * @cssproperty --dds-calendar-transition - The transition property for the calendar. Default is 'all 0.2s ease-in-out'.
 *
 * @cssproperty --dds-calendar-header-display - The display property of the calendar header. Default is grid.
 * @cssproperty --dds-calendar-header-grid-flow - The grid-auto-flow property of the calendar header. Default is column.
 * @cssproperty --dds-calendar-header-width - The width of the calendar header. Default is 100%.
 * @cssproperty --dds-calendar-header-gap - The gap between header items. Default is the design system's spacing-100.
 *
 * @cssproperty --dds-calendar-select-min-height - The minimum height of the select trigger. Default is auto.
 * @cssproperty --dds-calendar-select-max-height - The maximum height of the select trigger. Default is 32px.
 * @cssproperty --dds-calendar-select-padding - The padding of the select trigger. Default is the design system's spacing-200.
 * @cssproperty --dds-calendar-select-border-radius - The border radius of the select trigger. Default is the design system's radius-rounded.
 * @cssproperty --dds-calendar-select-border-color - The border color of the select trigger. Default is the design system's border-neutral-transparent-interactive.
 * @cssproperty --dds-calendar-select-background - The background color of the select trigger. Default is the design system's button-subtle-background-enabled.
 * @cssproperty --dds-calendar-select-color - The text color of the select trigger. Default is the design system's button-subtle-text-enabled.
 * @cssproperty --dds-calendar-select-font-size - The font size of the select trigger. Default is the design system's font-sm.
 * @cssproperty --dds-calendar-select-font-style - The font style of the select trigger. Default is normal.
 * @cssproperty --dds-calendar-select-font-weight - The font weight of the select trigger. Default is the design system's font-weight-bold.
 *
 * @cssproperty --dds-calendar-nav-button-margin - The margin of the navigation buttons. Default is the design system's spacing-200.
 * @cssproperty --dds-calendar-nav-button-color - The color of the navigation button icons. Default is the design system's button-subtle-icon-enabled.
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsChange: 'dds-change' as EventName<DdsChangeEvent>
        },
        displayName: "DapDSCalendar"
      })

      export default reactWrapper
    